import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { BotanicalDivider, CornerFlourish } from "./Botanical";
import { IMAGES } from "../../data/content";

export const About = () => (
    <section id="about" data-testid="about-section" className="relative overflow-hidden bg-ivory py-28 lg:py-40">
        <CornerFlourish className="pointer-events-none absolute left-0 top-0 opacity-70" />
        <CornerFlourish className="pointer-events-none absolute bottom-0 right-0 rotate-180 opacity-70" />

        <div className="mx-auto grid max-w-6xl items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-10">
            <div className="relative order-2 flex justify-center lg:order-1">
                <Reveal>
                    <div className="relative">
                        <motion.div
                            className="absolute -inset-5 rounded-full border border-gold/40"
                            initial={{ rotate: -8, opacity: 0 }}
                            whileInView={{ rotate: 0, opacity: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                        />
                        <div className="h-72 w-72 overflow-hidden rounded-full border-2 border-gold shadow-[0_25px_60px_-20px_rgba(14,59,46,0.35)] sm:h-96 sm:w-96">
                            <motion.img
                                src={IMAGES.about}
                                alt="Elegant floral arrangement in blush and ivory tones"
                                className="h-full w-full object-cover"
                                initial={{ scale: 1.15 }}
                                whileInView={{ scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
                            />
                        </div>
                        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-ivory px-5 py-1">
                            <span className="font-script text-3xl text-gold">with love</span>
                        </div>
                    </div>
                </Reveal>
            </div>

            <div className="order-1 lg:order-2">
                <SectionHeading
                    eyebrow="Our Philosophy"
                    title={<>Beauty in every <span className="italic text-gold-soft">detail</span></>}
                    align="left"
                />
                <Reveal delay={0.25}>
                    <p className="mt-8 font-cormorant text-xl italic leading-relaxed text-emerald-light sm:text-2xl" data-testid="about-mission">
                        "At Events by Leemerh, we believe every celebration deserves beauty,
                        elegance, and unforgettable memories."
                    </p>
                </Reveal>
                <Reveal delay={0.35}>
                    <p className="mt-6 text-sm leading-loose text-emerald-light/85 sm:text-base">
                        We create thoughtfully curated events tailored to your unique vision and
                        style. From the first sketch to the final candle lit, our craft is quiet
                        and deliberate — florals chosen at dawn, linens pressed to perfection,
                        light tuned to the exact warmth of the moment.
                    </p>
                </Reveal>
                <Reveal delay={0.45}>
                    <p className="mt-4 text-sm leading-loose text-emerald-light/85 sm:text-base">
                        Whether it is an intimate anniversary dinner or a grand ballroom wedding,
                        we plan so you can simply be present — a guest at your own celebration.
                    </p>
                </Reveal>
                <Reveal delay={0.55}>
                    <p className="mt-8 font-script text-3xl text-gold" data-testid="about-signature">
                        Turning moments into memories
                    </p>
                </Reveal>
                <Reveal delay={0.65}>
                    <BotanicalDivider className="mt-8" width={260} />
                </Reveal>
            </div>
        </div>
    </section>
);
